<template>
  <div class="school-home-page">
    <div class="frame">
      <div class="menu">
        <el-row>
          <el-col :span="24">
            <div class="logo_wrapper">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark">
                    <el-image class="logo_img" :src="
                        $store.state.user.userInfo.userImageUrl +
                          '?x-oss-process=image/resize,m_fill,h_100,w_100'
                      " fit="fill"></el-image>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="logo_name">
                    <el-tooltip effect="dark" :content="'账号:' + $store.state.user.userInfo.name" placement="top-start">
                      <span>
                        {{
                          $store.state.user.userInfo.realName &&
                          $store.state.user.userInfo.realName.length > 4
                            ? $store.state.user.userInfo.realName.slice(0, 4) +
                              '...'
                            : $store.state.user.userInfo.realName
                        }}
                      </span>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="logo_school">
                    <span style="color: #707070">
                      {{ $store.state.user.schoolInfo.name }}
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <el-menu :default-active="activeMenu" class="el-menu-demo" background-color="#ffffff" text-color="#383838" active-text-color="#383838" :collapse-transition="false">
          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item index="classroomIndex" @click="$router.push({ name: 'classroomIndex' })" id="class_step1">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-monitor"></i>
              <span style="margin-left: 10px; font-size: 16px" slot="title">教室首页</span>
            </el-menu-item>
          </div>

          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item index="myClass" @click="$router.push({ name: 'myClass' })">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-user"></i>
              <span style="margin-left: 10px;font-size: 16px" slot="title">我的班级</span>
            </el-menu-item>
          </div>

          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item index="works" @click="$router.push({ name: 'works' })">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-star-off"></i>
              <span style="margin-left: 10px; font-size: 16px" slot="title">课堂点评</span>
            </el-menu-item>
          </div>
          <!-- <el-submenu index="worksDetails">
            <template slot="title">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-star-off"></i>
              <span style="margin-left: 10px;font-size: 16px">课程点评</span>
            </template>
            <el-menu-item index="works" @click="$router.push({ name: 'works' })"><span
                style="margin-left: 40px">作品点评</span></el-menu-item>
            <el-menu-item index="worksDetails" @click="$router.push({ name: 'worksDetails' })"><span
                style="margin-left: 40px">课程点评</span></el-menu-item>
          </el-submenu> -->

          <!-- <el-menu-item index="classlistIndexTeacher" @click="$router.push({ name: 'classlistIndexTeacher' })">
            <i style="margin-left: 40px; font-size: 22px" class="el-icon-user"></i>
            <span style="font-size: 16px" slot="title">教学管理</span>
          </el-menu-item> -->

          <el-submenu index="classworks">
            <template slot="title">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-postcard"></i>
              <span style="margin-left: 10px;font-size: 16px">作品管理</span>
            </template>
            <el-menu-item index="classlistWorksStu" @click="$router.push({ name: 'classlistWorksStu' })"><span style="margin-left: 40px">学生作品</span></el-menu-item>
            <el-menu-item index="classlistWorks" @click="$router.push({ name: 'classlistWorks' })"><span style="margin-left: 40px">我的作品</span></el-menu-item>
          </el-submenu>

          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item index="prepare-lessons" @click="$router.push({ name: 'prepare-lessons' })">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-collection"></i>
              <span style="margin-left: 10px;font-size: 16px" slot="title">备课中心</span>
            </el-menu-item>
          </div>

          <!-- 师资培训 -->

          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item v-if="$store.state.user.userInfo.tchShiziAuth" index="trainingForTeachers" @click="$router.push({ name: 'trainingForTeachers' })" id="class_step1">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-video-play"></i>
              <span style="margin-left: 10px; font-size: 16px" slot="title">师资培训</span>
            </el-menu-item>
          </div>

          <!-- 教研培训 -->

          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item v-if="$store.state.user.userInfo.tchJiaoyanAuth" index="teachingAndResearchTraining" @click="$router.push({ name: 'teachingAndResearchTraining' })" id="class_step1">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-wind-power"></i>
              <span style="margin-left: 10px; font-size: 16px" slot="title">教研活动</span>
            </el-menu-item>
          </div>

          <!--
          <el-menu-item
            index="4"
            @click="$router.push({ name: 'classlistIndexTeacher' })"
          >
            <i class="el-icon-s-marketing"></i>
            <span slot="title">任务管理</span>
          </el-menu-item>
-->
        </el-menu>
      </div>
      <section>
        <container :classData="classData"></container>
      </section>
    </div>
  </div>
</template>

<script>
import container from './container'

export default {
  name: 'index',
  components: {
    container,
  },
  data() {
    return {
      nickName: '', //教师名字
      schoolName: '', //学校名称
      classData: {},
    }
  },

  computed: {
    activeMenu() {
      const route = this.$route
      const { meta } = route

      return meta.activeMenu
    },
  },

  mounted() {
    document.getElementById('home_top').style.display = 'block'
    //获取教师数据
    console.log('获取教师数据')
  },

  methods: {},
}
</script>

<style>
/* .el-submenu {
  min-width: 220px;
} */
</style>

<style scoped lang="scss">
.school-home-page {
  height: calc(100% - 60px);
  background-color: #f2f2f2;

  .logo_wrapper {
    width: 220px;
    height: 250px;
    background: #ffffff;
    color: #707070;

    .logo_img {
      border-radius: 50%;
      width: 100px;
      height: 100px;
      margin-left: 60px;
      margin-top: 60px;
    }

    .logo_name {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      margin-top: 10px;
    }

    .logo_school {
      text-align: center;
    }
  }

  .frame {
    display: flex;
    width: 100%;
    height: 100%;
    background: #f1f7fe;

    .menu {
      position: relative;
      z-index: 100;
      overflow-y: scroll;
      overflow-x: hidden;
      width: 220px;
      background-color: white;

      header {
        height: 30px;
      }

      .header-title {
        padding: 5px 0;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
      }

      .el-menu-demo:not(.el-menu--collapse) {
        width: 220px;
      }

      .el-menu-demo {
        height: calc(100% - 250px);
        border: 0px;
      }

      .el-menu-item.is-active {
        background-color: #e1edff !important;
      }

      /deep/.el-menu-demo .el-submenu {
        margin-left: 10px !important;
        margin-right: 10px !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        border-radius: 10px !important;
        min-width: auto;
        line-height: 50px !important;
      }

      /deep/.el-menu-demo .el-menu-item {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        border-radius: 10px !important;
      }

      /deep/.el-menu .el-menu-item:hover {
        outline: 0 !important;
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }

      /deep/.el-menu .el-menu-item.is-active {
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }

      .el-submenu /deep/.el-submenu__title:hover {
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }
    }

    .menu::-webkit-scrollbar {
      display: none;
    }

    section {
      flex: 1;
      overflow-y: auto;
    }
  }
}
</style>